import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[infoBannerHost]',
    standalone: false
})
export class InfoBannerHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
